export function FaqsTopicsIcon({ icon }) {
  return (
    icon && (
      <img src={`${scriptsData.themeUrl}/assets/images/icons-default/${icon}.svg`} alt={icon} />
    )
  );
}